export default {"src":"/_next/static/media/lv.3150640e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};